/**
 * Created by alvinoktavianus on 7/21/17.
 */

import React from 'react';

import IcLocked from 'assets/images/ic_locked@2x.png';
import styles from './FeatureBlockerPage.css';

const FeatureBlockerPage = () => {
  return (
    <div className={styles['blocker-page']}>
      <div>
        <p className="text-center">
          <img src={IcLocked} className={`img-circle ${styles.padlock}`} />
        </p>
        <h3 className="text-center">Feature Locked</h3>
        <p className={`text-center ${styles['blocker-message']}`}>
          Please contact your business owner to activate this feature.
        </p>
      </div>
    </div>
  );
};

export default FeatureBlockerPage;
